import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LeaderboardIcon(props: IconProps) {
    return <Icon {...props} iconKey={"leaderboard"}/>
}
